import constants from '../constants';
import getIconDialogCommonTraits from '../helpers/get-icon-dialog-common-traits';
import trackEvent from './track-event';

const { events } = constants;

export default function trackSelectIconTypeFilterSelected({
  dialogId,
  targetElementId,
  oldTypeId,
  newTypeId,
  tabId,
  premiumAvailable,
}) {
  const traits = {
    dialogId,
    oldTypeId,
    newTypeId,
    tabId,
    premiumAvailable,
    ...getIconDialogCommonTraits(targetElementId),
  };

  trackEvent(events.SELECT_ICON_TYPE_FILTER_SELECTED, traits);
}
